<template>
  <div class="cmp-gpt-main-navigation-bar">
    <div
      @click.prevent="onLogoClick"
      class="details-logo"
      style="cursor: pointer"
    >
      <img :src="'./static/icons/details_d.PNG'" alt srcset />
      <span>detailsGPT </span>

      <div class="dt-icon-container" @click.stop="$emit('newChat')">
        <img
          src="static/icons/edit.svg"
          class="close-icon dt-icon v5 h1 s3"
          alt
        />
      </div>
    </div>
    <div class="conversations">
      <div
        v-for="conversation in conversations.data"
        :key="conversation.title"
        :class="{
          'conversation-item': true,
          selected:
            conversation.conversation_id === selectedConversationId ||
            conversation.menu,
        }"
        @click="onConversationClick(conversation)"
      >
        <div class="conversation-title">
          {{ conversation.title }}
        </div>
        <!-- <v-menu
          :close-on-content-click="false"
          open-on-hover
          lazy
          left
          transition="scale-transition"
          offset-y
          full-width
          max-width="290px"
        >
          <div class="dt-icon-container" slot="activator">
            <img
              src="static/icons/options/options-grey-dark.svg"
              class="close-icon dt-icon v5 h1 s3"
              alt
            />
          </div>
        </v-menu> -->
        <v-menu
          :close-on-content-click="false"
          lazy
          left
          offset-y
          full-width
          max-width="290px"
          v-model="conversation.menu"
        >
          <div class="dt-icon-container" slot="activator">
            <img
              src="static/icons/options/options-grey-dark.svg"
              class="close-icon dt-icon v5 h1 s3"
              alt
            />
          </div>
          <v-list class="filter-more-options-list">
            <v-list-tile
              class="options-item"
              v-for="(item, index) in options"
              :key="index"
              @click="onConversationOptionClick(item, conversation)"
            >
              <v-list-tile-title
                :class="{
                  'ut-text-error': item.error ? true : false,
                }"
                >{{ item.text }}</v-list-tile-title
              >
            </v-list-tile>
          </v-list>
        </v-menu>
      </div>
    </div>
  </div>
</template>

<script>
import * as types from "../../../modules/b2b/store/types.js";
import { mapGetters } from "vuex";
import { SET_MAIN_NAV_ACTIVE } from "../../../store/app/types";
import { BookingDetails } from "../../../modules/booking/store/types";
import {
  handleCloseTab,
  handleCloseTabRoute,
} from "../../../dt-plugins/sidewindow/nav-tab";

import * as ActionTypes from "../../../store/app/types";
import {
  mapActionObject,
  mapAppActionObject,
  mapAppGetterObject,
} from "../../../store/global/index.js";
import { dtGPTActions } from "../../../store/app/dtgpt/actions";
import { dtGPTGetters } from "../../../store/app/dtgpt/getters";
import * as dtGPTTypes from "../../../store/app/dtgpt/types";

export default {
  props: {
    base: {
      type: String,
      default: "main",
    },
    items: {
      type: Array,
    },
    value: {
      required: false,
    },
  },
  mounted() {
    this[dtGPTTypes.DtGPTConversations.FETCH.ALL]();
  },
  computed: {
    ...mapAppGetterObject(dtGPTGetters),
    selectedConversationId() {
      return this.chat.conversation_id;
    },
    groupedConversations() {
      const sectionsMap = {};

      for (const item of this.conversations.data) {
        const sectionName = item.section;
        if (!sectionsMap[sectionName]) {
          sectionsMap[sectionName] = [];
        }
        sectionsMap[sectionName].push(item);
      }

      const sectionsArray = Object.keys(sectionsMap).map((sectionName) => ({
        name: sectionName,
        items: sectionsMap[sectionName],
      }));

      return sectionsArray;
    },
    options() {
      return [
        {
          text: "Delete",
          value: "delete",
        },
        {
          text: "Rename",
          value: "rename",
        },
        {
          text: "Favourite",
          value: "favourite",
        },
      ];
    },
  },
  methods: {
    ...mapAppActionObject(dtGPTActions),
    onLogoClick: function () {
      console.log("Logo clicked");
      this.$emit("logoclick", true);
    },
    onConversationClick(conversation) {
      // this[dtGPTTypes.DtGPTConversations.DELETE.SINGLE](conversation);
      this[dtGPTTypes.DtGPTChats.FETCH.SINGLE](conversation);

      this.$emit("showGPTChange", true);
    },
    onConversationOptionClick(option, conversation) {
      console.log("Option Clicked", option, conversation);

      if (option.value === "delete") {
        this[dtGPTTypes.DtGPTConversations.DELETE.SINGLE](conversation);
      }
    },
    //MARK: Methods
  },
};
</script>

<style lang="scss">
.main-nav {
  &.inactive {
    // background: blue;

    --text-accent: var(--text-accent-inactive);
    --sprt-85: var(--sprt-2);
    --sprt-95: var(--sprt-6);
    --bc-5: var(--bc-5-inactive);
    --bc-6: var(--bc-6-inactive);
  }
  .cmp-gpt-main-navigation-bar {
    // Z Index is required so users can select this on top of the Version UI
    z-index: 1;
    .navbar-options {
      width: 50px;
      margin: 5px 0px;
      button {
        margin-right: 5px;
        .close-icon {
          width: 40px;
          height: 40px;
          filter: grayscale(1);
        }
      }

      .close-button {
        // float: right;
        // margin-top: -80px;
      }
    }

    .details-logo {
      display: flex;
      // justify-content: center;
      margin-top: 10px;
      flex-direction: row;
      padding: 0 5px;

      img {
        width: 15%;
        height: 15%;
      }
      span {
        font-size: 120%;
        padding-left: 5px;
        color: var(--text-primary);
        font-family: "Roboto", sans-serif;
      }
      .dt-icon-container {
        img {
          width: 26px;
          height: 26px;
          text-align: right;
          margin-left: 35px;
        }
      }
    }

    .menu {
      max-width: 400px;
      margin: 0 auto;
      padding: 20px;

      .section {
        margin-bottom: 20px;
        h2 {
          color: #333;
          font-size: 18px;
          margin-bottom: 10px;
        }
        ul {
          list-style-type: none;
          padding: 0;
          margin: 0;
        }
        ul {
          li {
            margin: 5px 0;
          }
        }
        a {
          color: #0066cc;
          text-decoration: none;

          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
    .conversations {
      margin: 8px;

      .conversation-item {
        padding: 8px;
        height: 36px;

        border-radius: 8px;
        cursor: pointer;

        // display: flex;
        position: relative;

        .menu {
          position: absolute;
          right: 10px;
          top: 0px;
        }

        .dt-icon-container {
          position: absolute;
          // right: 10px;
          top: 0px;
          // display: none;
          opacity: 0;
          z-index: -99;
          // top: 50%;
          // transform: translateY(-50%);
        }

        &:hover,
        &.selected {
          background: hsl(0, 0%, 85%);

          .dt-icon-container {
            opacity: 1;
            z-index: 1;
            background: hsl(0, 0%, 85%);
          }
        }
        // &.selected {
        //   background: hsl(0, 0%, 85%);

        //   .dt-icon-container {
        //     opacity: 1;
        //     z-index: 1;
        //     background: hsl(0, 0%, 85%);
        //   }
        // }

        .conversation-title {
          // font-size: 14px;
          // color: var(--text-primary);
          // font-weight: 500;

          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
      }
    }
  }
}

// .active {
//   background-color: #d8d5d5;
// }
</style>
